<template>
    <div>
        <b-navbar toggleable="lg" type="light" id="navbar" fixed="top" >
            <img @click="toggle" v-if="showLeft" src="../assets/right_arrow.svg" id="right-arrow"/>
            <img @click="toggle" v-else-if="showRight" src="../assets/left_arrow.svg" id="left-arrow"/>
            <b-navbar-brand to="/"><a class="brand-tag">
                <img src="../assets/pp_logo_3_cleaner.svg" id="logo" width=75% height=auto alt="Product Planet logo"/></a></b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
           

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <!--<b-nav-item to="/dashboard" class="item">Dashboard</b-nav-item>-->
                <!--<b-nav-item to="/dashboard/learn" class="item">Learn</b-nav-item>-->
                <!--<b-nav-item to="/dashboard/practice" class="item">Practice</b-nav-item> -->
                <!--<b-nav-item to="/dashboard/jobs" class="item">Jobs</b-nav-item> -->
                
                <!--<b-nav-item to="/dashboard" id="item2">Inspirations</b-nav-item> -->
                    
                <!-- Using 'button-content' slot -->
                    
            </b-navbar-nav>
            <b-nav-item-dropdown v-if="isAuthenticated === true" id="dropdown" no-caret right>
                <template slot="button-content"><b-img alt="" rounded="circle" :src="photoURL" class="displaypic"></b-img></template>
                <b-dropdown-item class="fa-text" v-on:click="goToProfile"><i class='fa fa-user'></i>Dashboard</b-dropdown-item>
                <b-dropdown-item class="fa-text" v-on:click="signOut"><i class='fa fa-sign-out'></i>Sign Out</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-navbar-nav v-if="isAuthenticated === false">
                <b-nav-item class="avatar">
                    <b-button variant="outline" class="section-btns" v-on:click="signUp">LOGIN</b-button>
                </b-nav-item>
                <b-nav-item class="avatar">
                    <b-button variant="success" class="section-btns" v-on:click="signUp">SIGN UP</b-button>
                </b-nav-item>
            </b-navbar-nav>
            
        </b-collapse>
    </b-navbar>
</div>
</template>
    


<script>
import firebase from '../services/firebase'

export default {
    name: 'NavBarLight',
    props: {
        showRight: Boolean,
        showLeft: Boolean
    },
    data: function() {
        return {
            currUser: null,
            isAuthenticated: true,
            photoURL: '',
            email: '',
            name: ''
        }
    },
    created: function() {
        firebase.auth().onAuthStateChanged((user) => {
            if(user) {
                this.currUser = user;
                console.log("logged in user email is " + this.currUser.email);
                this.isAuthenticated = true;
                this.email = this.currUser.email;
                this.name = this.currUser.displayName;
                this.photoURL = this.currUser.photoURL;
            } else {
                console.log("user does not exist, sorry");
                this.isAuthenticated = false;
            }
        });
    },
    methods: {
        signUp: function() {
          console.log("inside signUp vue function");
          var provider = new firebase.auth.GoogleAuthProvider();
          var user = firebase.auth().currentUser;
          if (user === undefined || user === null) {
              firebase.auth().signInWithPopup(provider).then(function(result) {
                var user = result.user;
                var token = result.credential.accessToken;
                localStorage.token = token;
                if (user) {
                    console.log("user with email" + user.email + "is signed in");
                    this.$router.push('/home');
                }
              }).catch(function(error) {
                console.log("signin error with errorCode" + error.code + " and message " + error.message); 
              })
          } else {
              console.log("email is " + user.email);
              this.$router.push('/home');
          }
          
        },
        signOut: function() {
            console.log("in sign out function");
            this.$router.push('/home');
            firebase.auth().signOut().then(function() {
                console.log("signed out successfully");
                localStorage.token = null;
                
            }).catch(function(err) {
                console.log("could not log you out, error " + err);
            });
        },
        goToProfile: function() {
            this.$router.push('/dashboard');
        },
        toggle: function() {
            this.$emit('toggleArrow');
        }
    }
}
</script>

<style scoped>

    @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

    .navbar.navbar.navbar-light.navbar-expand-lg {
        background-color:#fff;
        box-shadow: 0 4px 2px -2px #eee;
        -webkit-box-shadow: 0 4px 2px -2px #eee;
        -moz-box-shadow: 0 4px 2px -2px #eee;
    }

    #logo {
        margin-right:0px; 
        margin-bottom:0px;
        margin-top:0px;
    }


    #right-arrow {
        width: 24px;
        height: 24px;
        cursor: pointer;
        margin-right: 0px;
    }
    

    #left-arrow {
        width: 24px;
        height: 24px;
        cursor: pointer;
        margin-right: 0px;
    }
    

    .navbar-light.navbar-nav.nav-link {
        color: #555;
    }

    .navbar-light .navbar-brand {
        margin-left:0px;
    }

    .navbar-light .navbar-nav .nav-link{
      color:#555!important;
      font-size:1rem;
      font-weight: 500;
    }

    .item {
      margin-right:10px;
      margin-left:10px;    
    }

    .btn.section-btns.btn-outline{
        border-color:#f25792;
        color: #f25792;
        background-color: #fff;
        border:#f25792 solid 2px;
        border-radius: 7px;
        padding-left: 14px;
        padding-right: 14px;
        padding-top:7px;
        padding-bottom:7px;
        margin-bottom:-9px;
    }

    .btn.section-btns.btn-success{
        border-color:#f25792;
        color: #fff;
        background-color: #f25792 !important;
        border:#f25792 solid 2px;
        border-radius: 7px;
        padding-left: 14px;
        padding-right: 14px;
        padding-top:7px;
        padding-bottom:7px;
        margin-bottom:-9px;
    }

    .ml-auto {
        color:#555;
        margin-right:20px;
        margin-top:10px;
    }

    .displaypic {
        border-radius: 50%;
        margin-top:5px;
        height:30px;
        width:30px;
    }

    #dropdown {
        list-style-type: none;
        padding:0;
    }

    .dropdown-toggle::after {
        color:#888;
        display:none;
    }

    .dropdown-item {
        color:#555;
        font-size:0.8rem;
        padding-top:10px;
        padding-bottom:10px;
    }

    .dropdown-menu {
        border-radius: 0;
        box-shadow: 0 2px 1px -1px #eee;
        -webkit-box-shadow: 0 2px 1px -1px #eee;
        -moz-box-shadow: 0px 2px 1px -1px #eee;
        border-color: #eee;
        background-color:#fff;
        padding: 0 !important;
    }

    .dropdown-menu.dropdown-menu-right.show {
        padding: 0;
    }

    .fa {
        margin-right: 20px;
    }

    .fa-text {
        font-size: 0.9rem;
        color: #555;
    }
   
</style>
